import styled from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import Widget from '~/src/components/Widget';

export const WidgetContent = styled(Widget.ContentBlock)`
    background-color: ${COLORS.BgSurface};
    border-radius: 0 0 ${BorderRadius.OuterBlockRadius} ${BorderRadius.OuterBlockRadius};
`;

export const PackageInfo = styled.div`
    flex: 1 1 auto;
    flex-direction: column;
    flex-wrap: nowrap;
    margin-bottom: -15px;
`;

export const PackageDesc = styled.div`
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};
    display: -webkit-box;
    display: -moz-box;
    display: box;
    -webkit-box-orient: vertical;
    --moz-box-orient: vertical;
    box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
`;

export const PackageChannelsCount = styled.div`
    ${FONTS.XXS};
    color: ${COLORS.TextSecondary};
    margin: auto 0 2px;
`;

export const WidgetPrice = styled(Widget.Price)<{ isPromoPrice: boolean }>`
    color: ${({ isPromoPrice }) => isPromoPrice ? COLORS.LabelsText_2 : COLORS.TextSecondary};
`;

export const ButtonsWrapper = styled.div`
    display: grid;
    grid-template-columns: auto 36px;
    gap: 8px;
`;
